import React, { Component } from "react"
import PropTypes from "prop-types"
import queryString from "query-string"
import SbEditable from "storyblok-react"
import Components from "../../index"
import IconV2 from "../../icon-v2"
import instagramIcon from "../../../assets/images/instagram.png"
import messengerIcon from "../../../assets/images/messenger.png"
import ButtonV2 from "../../button-v2"
import {
  StyledHeroCardCta,
  StyledHeroCardOptions,
  StyledHeroCardOption,
  StyledHeroCardOptionIcon,
  StyledHeroCopyLink,
} from "../partials"

class ShareOptions extends Component {
  state = {
    navigatorShareExists: false,
  }
  componentDidMount() {
    if (typeof navigator.share !== "undefined") {
      this.setState({
        navigatorShareExists: true,
      })
    }
  }
  copyUrlClipboard() {
    const copyText = document.getElementById("copyLink")
    copyText.select()
    copyText.setSelectionRange(0, 99999)
    document.execCommand("copy")
    alert("URL copied to clipboard")
    window.dataLayer.push({
      event: "hultedu_socialShare",
      eventMeta: {
        content: "Copy Link",
        timestamp: JSON.stringify(new Date()),
      },
    })
  }
  nativeShare(blok) {
    if (navigator.share) {
      navigator
        .share({
          title: this.props.shared_title,
          url: this.props.shared_url,
        })
        .then(() => {
          window.dataLayer.push({
            event: "hultedu_socialShare",
            eventMeta: {
              content: "Native Share",
              timestamp: JSON.stringify(new Date()),
            },
          })
        })
        .catch(console.error)
    }
  }

  socialClick(link, platform) {
    if (typeof window !== "undefined") {
      window.dataLayer.push({
        event: "hultedu_socialShare",
        eventMeta: {
          content: platform,
          timestamp: JSON.stringify(new Date()),
        },
      })
      window.location.href = link
    }
  }

  render() {
    return (
      <>
        <StyledHeroCardOptions>
          {this.props.linkedin && (
            <StyledHeroCardOption
              onClick={() =>
                this.socialClick(
                  `https://www.linkedin.com/sharing/share-offsite/?url=${this.props.shared_url}`,
                  "LinkedIn"
                )
              }
            >
              <StyledHeroCardOptionIcon option="linkedin">
                <IconV2 size="26" iconType="fab" icon="linkedin-in" />
              </StyledHeroCardOptionIcon>
            </StyledHeroCardOption>
          )}
          {this.props.instagram && (
            <StyledHeroCardOption>
              <StyledHeroCardOptionIcon option="instagram">
                <img src={instagramIcon} />
              </StyledHeroCardOptionIcon>
            </StyledHeroCardOption>
          )}
          {this.props.whatsapp && (
            <StyledHeroCardOption
              onClick={() =>
                this.socialClick(
                  `whatsapp://send?text=${this.props.shared_url}`,
                  "WhatsApp"
                )
              }
            >
              <StyledHeroCardOptionIcon option="whatsapp">
                <IconV2 size="26" iconType="fab" icon="whatsapp" />
              </StyledHeroCardOptionIcon>
            </StyledHeroCardOption>
          )}
          {this.props.email && (
            <StyledHeroCardOption
              onClick={() =>
                this.socialClick(
                  `mailto:?subject=${this.props.shared_title}&body=${this.props.shared_url}`,
                  "Email"
                )
              }
            >
              <StyledHeroCardOptionIcon>
                <IconV2 size="26" iconType="far" icon="envelope" />
              </StyledHeroCardOptionIcon>
            </StyledHeroCardOption>
          )}
          {this.props.sms && (
            <StyledHeroCardOption
              onClick={() =>
                this.socialClick(`sms:&body=${this.props.shared_url}`, "SMS")
              }
            >
              <StyledHeroCardOptionIcon option="sms">
                <IconV2 size="26" iconType="far" icon="sms" />
              </StyledHeroCardOptionIcon>
            </StyledHeroCardOption>
          )}
          {this.props.messenger && (
            <StyledHeroCardOption
              onClick={() =>
                this.socialClick(
                  `https://www.facebook.com/sharer/sharer.php?u=#${this.props.shared_url}`,
                  "Messenger"
                )
              }
            >
              <StyledHeroCardOptionIcon option="messenger">
                <img src={messengerIcon} />
              </StyledHeroCardOptionIcon>
            </StyledHeroCardOption>
          )}
          {this.props.copy_link && (
            <StyledHeroCardOption onClick={() => this.copyUrlClipboard()}>
              <StyledHeroCardOptionIcon>
                <IconV2 size="26" iconType="far" icon="link" />
              </StyledHeroCardOptionIcon>
            </StyledHeroCardOption>
          )}
        </StyledHeroCardOptions>
        <StyledHeroCopyLink
          type="text"
          defaultValue={this.props.shared_url}
          id="copyLink"
        />
      </>
    )
  }
}

export default ShareOptions
